import { useEffect, useRef } from 'react';

/**
 * Trailing-edge debounce. The latest `fn` is called once after `delay` ms
 * of no further `trigger` value changes. Pending calls are flushed on unmount.
 */
export function useDebouncedEffect(
  fn: () => void | Promise<void>,
  trigger: unknown,
  delay = 500,
) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const t = setTimeout(() => {
      void fnRef.current();
    }, delay);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, delay]);
}
